export const REDUX_SET_CONNECTIVITY_STATUS = 'REDUX_SET_CONNECTIVITY_STATUS'
export const REDUX_SET_NETWORK_ERROR = 'REDUX_SET_NETWORK_ERROR'
export const REDUX_CLEAR_NETWORK_ERROR = 'REDUX_CLEAR_NETWORK_ERROR'
